import * as React from 'react';
type SvgYoutubeProps = React.SVGProps<SVGSVGElement>;

const SvgYoutube = (props: SvgYoutubeProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="37"
    fill="none"
    viewBox="0 0 38 37"
  >
    <rect
      width="37"
      height="37"
      x="0.5"
      fill="#fff"
      fillOpacity="0.1"
      rx="4.933"
    ></rect>
    <g fill="#fff" clipPath="url(#clip0_1041_11943)">
      <path d="M31.094 13.633c0-.086-.26-1.989-1.081-2.897-.995-1.08-2.076-1.21-2.638-1.254h-.173c-3.502-.26-8.734-.302-8.82-.302-.044 0-5.319.043-8.778.389h-.13c-.605.043-1.686.173-2.637 1.254-.865.908-1.124 2.854-1.124 2.94 0 0-.26 2.205-.26 4.41v2.033c0 2.162.26 4.367.26 4.41 0 .086.259 1.989 1.08 2.897.909 1.038 1.99 1.167 2.681 1.254.13 0 .217 0 .346.043 1.99.173 8.302.26 8.561.26.044 0 5.319 0 8.821-.39h.13c.605-.043 1.686-.173 2.637-1.254.865-.908 1.125-2.853 1.125-2.94 0 0 .26-2.205.26-4.41v-2.032c0-2.162-.26-4.367-.26-4.41m-.606 6.53c0 2.161-.26 4.323-.26 4.323-.086.476-.345 1.86-.907 2.465-.735.864-1.6.951-2.076.994h-.13c-3.458.26-8.69.26-8.733.26s-6.53-.087-8.432-.303c-.13 0-.26-.043-.39-.043-.605-.043-1.47-.173-2.161-.951-.519-.562-.822-1.946-.865-2.422 0-.043-.26-2.205-.26-4.324V18.13c0-2.162.26-4.324.26-4.324.043-.475.346-1.859.865-2.464.778-.865 1.6-.952 2.119-.995h.13c3.458-.26 8.69-.303 8.734-.303.043 0 5.275.044 8.734.303h.173c.475.043 1.34.13 2.075.995.519.605.778 1.989.865 2.464.043.087.26 2.249.26 4.324z"></path>
      <path d="m23.786 19.165-8.216-4.8a.39.39 0 0 0-.432 0 .45.45 0 0 0-.216.39v9.383c0 .172.086.302.216.389a.4.4 0 0 0 .216.043c.087 0 .13 0 .216-.043l8.216-4.584a.45.45 0 0 0 .216-.389.45.45 0 0 0-.216-.389m-8 4.238V15.49l6.919 4.064z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1041_11943">
        <path fill="#fff" d="M5.43 6.168h25.9v25.9H5.43z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SvgYoutube;
